import Vue from 'vue'

const Plugin = {
	install() {
		const root = new Vue()
		Vue.prototype.$sfcModalManager = root

		Vue.prototype.$sfcModal = {
			params: {},

			open (id, params) {
				this.params = params
				root.$emit('sfc-modal-open', id)
			},

			close (id) {
				root.$emit('sfc-modal-close', id)
			}
		}
	}
}

Vue.use(Plugin)
